import React from 'react';

import '../Button/ConfirmBrandButton.less';

const ConfirmBrandButton = ({
    brandImage,
    flagImage,
    language,
    domain,
    currencies,
    confirmBrand,
    buttonId,
    enableButton
}) => {
    return (
        <button 
            className="confirm-brand-button"
            type="submit"
            id={buttonId} 
            onClick={confirmBrand}
            disabled={!enableButton}
        >
            <div className="brand-section">
                <img className="brand-logo" src={brandImage} />
                <div className="domain">{domain}</div>
            </div>
            <div className="vertical-divider"/>

            <div className="language-section">
                <span className="language-label">{'Language'}</span>
                <div className="language-content">
                    <img className="language-flag" src={flagImage}/>
                    <span className="language-text">{language}</span>
                </div>
            </div>

            <div className="currency-section">
                <span className="currency-label">{'Currency'}</span>
                <span className="currency-text">{currencies}</span>
            </div>
        </button>
    );
}

export default ConfirmBrandButton;